import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged, User } from "firebase/auth";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import getCurrentUserData from "../api/auth/getCurrentUserData";
import { selectUserLoginState, userSliceActions } from "../store/features/user";
import { currentAdminbusinessActions } from "../store/features/currentBusiness";
import { currentAdminShopActions } from "../store/features/currentBusinessShop";
import { IUserSchema } from "shared/types";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: "AIzaSyAzGvU9Ha_gnogzFbrcJMnbvdhZIygD020",
  authDomain: "the-shopkeeper.firebaseapp.com",
  projectId: "the-shopkeeper",
  storageBucket: "the-shopkeeper.appspot.com",
  messagingSenderId: "567233233708",
  appId: "1:567233233708:web:aa3dc167ad1de791a02289",
  measurementId: "G-HZX4FNPW6W"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export default function useWatchUserState() {
  const [currentUser, setCurrentUser] = useState<User|null>(null);

  const auth = getAuth();
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector(selectUserLoginState);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setCurrentUser(user);

      if (user) {
        const currentUserData = await getCurrentUserData() as unknown as IUserSchema;

        dispatch(
          userSliceActions.setUserProps({
            ...currentUserData,
            emailVerified: user.emailVerified,
            created_at: new Date(currentUserData.created_at).toDateString(),
            uid: user.uid,
          })
        );
        dispatch(userSliceActions.logIn());
      } else {
        dispatch(userSliceActions.logOut());
        dispatch(userSliceActions.resetUserProps());
        dispatch(
          currentAdminbusinessActions.setCurrentBusinessMetadata({
            total_shops: 0,
            name: "",
            best_performing_shop: "",
            gross_revenue: 0,
            gross_profit: 0,
            total_sales: 0,
          })
        );
        dispatch(currentAdminbusinessActions.setCurrentBusinessShops([]));
        dispatch(currentAdminShopActions.clearCurrentAdminShop());
      }
    });

    return () => unsubscribe();
    //eslint-disable-next-line
  }, [isUserLoggedIn, currentUser]);
}
